/*
 * @Description:
 * @version:
 * @Date: 2024-02-05 10:33:33
 * @LastEditTime: 2024-02-05 10:36:06
 */

export const localSave = (key, value) => {
  localStorage.setItem(key, value);
};

export const localRead = (key) => {
  return localStorage.getItem(key) || '';
};

export const localRemove = (key) => {
  if (key) {
    localStorage.removeItem(key);
  }
};

export const localClear = () => {
  localStorage.clear();
};
